import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const NotificationUnread = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 44}
        height={size ?? 44}
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_1304_4023)">
          <circle cx="22" cy="22" r="6" fill={color} />
        </g>
        <defs>
          <filter
            id="filter0_d_1304_4023"
            x="0"
            y="0"
            width="44"
            height="44"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="5"
              operator="dilate"
              in="SourceAlpha"
              result="effect1_dropShadow_1304_4023"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="5.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.164706 0 0 0 0 0.886275 0 0 0 0 0.396078 0 0 0 0.25 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1304_4023" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1304_4023"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  },
);

export default NotificationUnread;
